/**
 * Client-side id generation. Ids must never contain ":" (cell keys are
 * "rowId:colId" — @kola/shared cellKey), so the alphabet is alphanumeric.
 */

// Single implementation lives in @kola/shared (used by the server-side board
// seeding too); re-exported here for the grid's column titles.
export { columnLabel } from "@kola/shared";

const ALPHABET = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";

export function newId(size = 12): string {
  const bytes = crypto.getRandomValues(new Uint8Array(size));
  let id = "";
  for (const byte of bytes) {
    id += ALPHABET[byte % ALPHABET.length];
  }
  return id;
}
